module.exports = __webpack_public_path__ + "img/x4.a9379495.jpg";